import script from "./DiscoverView.vue?vue&type=script&setup=true&lang=ts"
export * from "./DiscoverView.vue?vue&type=script&setup=true&lang=ts"

import "./DiscoverView.vue?vue&type=style&index=0&id=e2326e96&lang=scss"

const __exports__ = script;

export default __exports__